import React from 'react';
export const GruserContext = /*#__PURE__*/ React.createContext(undefined);
GruserContext.displayName = 'GruserContext';
export default GruserContext;
